export const SessionQueries = {
  CLIENT_AND_DATE: "Client and Date of service",
  CLIENT: "Client",
  DATE_OF_SERVICE: "Date of service",
  PROVIDER: "Provider",
  SESSION_ID: "Session ID",
};
